import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://cbd1c97b04a4dcd9987f4ca5b8edeef9@sentry.cloud.orion.global/4',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  // sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      // Specific configuration for sessions
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0.4,
  profilesSampleRate: 0.2,
  replaysSessionSampleRate: 0.3,
  replaysOnErrorSampleRate: 0.8,
  environment: import.meta.env.VITE_ENVIRONMENT,
  enabled: import.meta.env.VITE_ENVIRONMENT !== 'local',

  // Session tracking configuration
  beforeSend(event) {
    // Track session health and enhance error context
    if (event.exception) {
      // Add additional context for crashed sessions
      event.tags = {
        ...event.tags,
        sessionStatus: 'crashed',
        component: 'hub-frontend',
      };
    }
    return event;
  },

  // Additional configuration for better session tracking
  initialScope: {
    tags: {
      component: 'hub-frontend',
    },
  },

  // Enable session health tracking
  release: import.meta.env.VITE_APP_VERSION || 'development',
});

// Add global error handler for unhandled errors
window.addEventListener('error', (event) => {
  Sentry.captureException(event.error || new Error(event.message), {
    tags: {
      errorBoundary: 'global',
      component: 'window',
      sessionStatus: 'crashed',
    },
    extra: {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    },
  });
});

// Add global promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason, {
    tags: {
      errorBoundary: 'global',
      component: 'promise',
      sessionStatus: 'crashed',
    },
  });
});

// Function to manually track session health
export const trackSessionHealth = (status: 'healthy' | 'crashed' | 'abnormal') => {
  Sentry.addBreadcrumb({
    message: `Session status: ${status}`,
    category: 'session',
    level: status === 'crashed' ? 'error' : 'info',
  });

  Sentry.setTag('sessionHealth', status);
};
